import { getSupabaseConnectionMode } from '../config/supabase';

/** Upload z panelu do Storage przy wyłączonym proxy wymaga service role w admin/.env */
export function canUploadContactPhotosFromPanel() {
  if (getSupabaseConnectionMode() === 'proxy') {
    return false;
  }
  return !!process.env.REACT_APP_SUPABASE_SERVICE_ROLE_KEY?.trim();
}

export function getStorageUploadBlockedMessage() {
  if (getSupabaseConnectionMode() === 'proxy') {
    return (
      'Przy włączonym proxy upload do Supabase Storage z panelu zwykle nie działa. ' +
      'Wyłącz proxy w Zarządzanie, wklej link z Storage albo wgraj plik lokalnie przy wyłączonym proxy z REACT_APP_SUPABASE_SERVICE_ROLE_KEY w admin/.env.'
    );
  }
  return (
    'Upload wymaga REACT_APP_SUPABASE_SERVICE_ROLE_KEY w pliku admin/.env (Supabase → Project Settings → API → service_role). ' +
    'Zapisz .env, zrestartuj npm start. Bez tego klucza Storage blokuje zapis (RLS). Alternatywa: wklej publiczny link z Supabase Storage.'
  );
}

export function formatStorageUploadError(error) {
  const msg = error?.message || String(error);
  if (/row-level security|violates row-level security|RLS/i.test(msg)) {
    return getStorageUploadBlockedMessage();
  }
  return msg || 'Błąd podczas przesyłania zdjęcia';
}
